
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.688 4.031c.837 0 1.679.335 2.313.969a3.251 3.251 0 010 4.594l-.031.063-.063.063.594.594-16.5 16.5-.313.063-5.5 1.094-1.469.313.313-1.469 1.094-5.5.063-.313 16.5-16.5.625.594.094-.094c.633-.633 1.444-.969 2.281-.969zm0 1.969c-.312 0-.608.14-.875.406l-.094.094L25.5 8.281l.094-.094c.533-.533.533-1.248 0-1.781C25.327 6.139 25 6 24.688 6zm-2.969 1.313L20.25 8.751l3 3 1.438-1.469zm-2.844 2.875L8.406 20.626l1.813.406.625.125.125.625.406 1.813 10.438-10.469zM6.969 22.344l-.406 2.031 1.063 1.063 2.031-.406-.5-2.188z"}})])
          )
        }
      }
    